import { Navigate } from "react-router-dom";

function VolunteerProtected({ children }) {
  const volunteer = sessionStorage.getItem("volunteerData");

  if (!volunteer) {
    return <Navigate to="/volunteer/login" replace />;
  }

  try {
    const parsed = JSON.parse(volunteer);
    const token = parsed.accessToken;

    if (!token) {
      sessionStorage.removeItem("volunteerData");
      sessionStorage.removeItem("volunteerToken");
      return <Navigate to="/volunteer/login" replace />;
    }

    const payload = JSON.parse(atob(token.split(".")[1]));
    const isExpired = payload.exp * 1000 < Date.now();

    if (isExpired) {
      sessionStorage.removeItem("volunteerData");
      sessionStorage.removeItem("volunteerToken");
      return <Navigate to="/volunteer/login" replace />;
    }

    return children;
  } catch {
    sessionStorage.removeItem("volunteerData");
    sessionStorage.removeItem("volunteerToken");
    return <Navigate to="/volunteer/login" replace />;
  }
}

export default VolunteerProtected;
